/* ============
 * AWS Gateway API
 * Java API for card linking
 * ============
 */

import Vue from 'vue'
import apigClientFactory from '@/api/apigClientJ'

/* eslint-disable new-cap */
const apij = new apigClientFactory.newClient({})

Vue.$apij = apij
Object.defineProperty(Vue.prototype, '$apij', {
  get () {
    return apij
  }
})

export default apij



// WEBPACK FOOTER //
// ./src/app/plugins/apij.js